import React from "react";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Col, CardBody } from "reactstrap";
import { Form } from "react-bootstrap";
//import { withRouter } from 'react-router-dom';
import EditIcon from '@material-ui/icons/Create';
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import GeoCoding from "../transaction/order/GeoCoding";
import { connect } from "react-redux";
import { toast } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import dateFormat from 'dateformat';
import moment from "moment";
import { logincheck } from '../Userlogin/Userlogin'


class DeliveryAddress extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [""], associateId: "", address: "", lat: "", lng: "", zone: "", label: "",
            editLabel: "", editDefaultAddress: "", addressId: "",
            editAddress: false, toggleAddress: false, toggleCheckAddress: false, disableSubmit: false,
			validmap:"0", btnsb :'0'
        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
    }

    componentDidMount() {
        let userId = this.props.userId;
        let userRole = this.props.userRole;
		logincheck(this.props.userId, this.props.mobiledevice).then(({ data: data }) => {
			console.log(data.status_check)
			if(data.status_check === 0) {
				this.props.history.push({ pathname: `/Logout`, state: { userId : this.props.userId , logintoken: 2 } });
			}
		})
        if (userRole === "Apartment Customer") {
            this.getApartmentID(userId);
        }
        else if (userRole === "Corporate Customer") {
            this.getCorporateID(userId);
        }
        else if (userRole === "Individual Customer") {
            this.getIndividualId(userId);
        }
    }

    getIndividualId = (userId) => {
        const url = process.env.REACT_APP_NODE_ENV + "/api/indiv-customer/getIndividualIdByUser/" + userId;
        fetch(url,{
            method:'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
              }
        }).then(
            response => { return response.json(); }
        ).then(data =>{
		
		if(data.length != 0) {
			this.setState({ associateId: data[0].individualId }, () => this.getAllAddress(data[0].individualId))
		}
		else {
			toast.dismiss()
			toast.error("Please complete your profile to proceed", {
			position: toast.POSITION.TOP_CENTER,
			autoClose: 2000
			});
			this.props.history.push({ pathname: "/indiv-customer/customer-create-user", data: "" });
			
		}
            
        })
    }

     getApartmentID = (userId) => {
        const url = process.env.REACT_APP_NODE_ENV + "/api/apart-customer/getApartmentIdByUser/" + userId;
        fetch(url,{
            method:'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
              }
        }).then(
            response => { return response.json(); }
        ).then(data => {
			if(data.length != 0) {
		
            this.setState({ associateId: data[0].apartmentId }, () => this.getAllAddress(data[0].apartmentId))
			}
			else {
				toast.dismiss()
			toast.error("Please complete your profile to proceed", {
			position: toast.POSITION.TOP_CENTER,
			autoClose: 2000
			});
			this.props.history.push({ pathname: "/aprt-customer/customer-user-create", data: "" });
			}
			
			
        })
    }

    getCorporateID = (userId) => {
        const url = process.env.REACT_APP_NODE_ENV + "/api/corp-customer/getCustomerIdByUser/" + userId;
        fetch(url,{
            method:'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
              }
        }).then(
            response => { return response.json(); }
        ).then(data => {
				if(data.length != 0) 
				{
					this.setState({ associateId: data[0].corporateId }, () => this.getAllAddress(data[0].corporateId))
				}
				else {
					toast.dismiss()
					toast.error("Please complete your profile to proceed", {
					position: toast.POSITION.TOP_CENTER,
					autoClose: 1000
					});
					
					this.setState({ entityId: "" })
					this.props.history.push({ pathname: "/corp-customer/customer-create-user", data: "" });
				}
            
        })
    }

    getAllAddress(value) {
        const url5 = process.env.REACT_APP_NODE_ENV + "/api/address/getAddressbyCustomerId/" + value
        fetch(url5,{
            method:'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
              }
        }).then(
            response => {
                if (!response.ok) throw new Error(response.status);
                else return response.json();
            }
        ).then(data =>
            this.setState({ Data: data }))
            .catch(error => console.log(error))
    }

    addNewAddress = () => {
		
        if (this.validator.allValid()) {
			
            const { associateId, address, lat, lng, zone, label } = this.state;
			console.log(lat, lng)
			if(lat === "" && lng  === "") {
				
				this.setState ({ validmap : '1' })
				
			}
			else {
				this.setState ({ validmap : '0' })
            let postAddressData = {
                associateId: associateId, defaultAddress: "No",
                fullAddress: address, geolocationLat: lat, geolocationLng: lng, zone: zone, label: label
            };
            fetch(process.env.REACT_APP_NODE_ENV + '/api/address/createAddress', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
                  },
                body: JSON.stringify(postAddressData)
            }).then(response => { 
                response.json();
                if (response.status === 406) {
                    toast.error("Address already exist.", {
                        position: toast.POSITION.TOP_CENTER,
                    })
                }
				else {
					 toast.success("Address created successfully.", {
                        position: toast.POSITION.TOP_CENTER,
                    })
				}
            })
                .then(data => {
                    this.validator.hideMessages();
					
                    this.setState({
                        address: "", lat: "", lng: "", zone: "", label: "",
                        toggleAddress: false,
                        toggleCheckAddress: false, zoneFlag: false, disableSubmit: false
                    }, () => this.componentDidMount())
                })
                .catch(error => console.log(error))
			}
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
		
		
    }

    editOldAddress = () => {
        const { associateId, editLabel, editDefaultAddress, addressId } = this.state;
		console.log(editDefaultAddress)
        let postAddressData = {
            associateId: associateId, id: addressId, label: editLabel, defaultAddress: editDefaultAddress
        };
        fetch(process.env.REACT_APP_NODE_ENV + '/api/address/updateAddress', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
              },
            body: JSON.stringify(postAddressData) 
        }).then(response => response.json())
            .then(data => {
				
				if(data.error_code  === 1) {
						toast.error("Default Address cannot be Changed.", {
						position: toast.POSITION.TOP_CENTER,
					})
					this.setState({
						editLabel: "", editDefaultAddress: "", editAddress: false, addressId: ""
					}, () => this.componentDidMount())
				
				}
				else if(editDefaultAddress === 'Yes'){
					toast.success("Status update successfully.", {
						position: toast.POSITION.TOP_CENTER,
					})
					this.setState({
						editLabel: "", editDefaultAddress: "", editAddress: false, addressId: ""
					}, () => this.componentDidMount())
				}
				else {
					 this.setState({
                    editLabel: "", editDefaultAddress: "", editAddress: false, addressId: ""
                }, () => this.componentDidMount())
					
				}
            })

    }

    editHandler = (value) => {
        this.setState({ editAddress: true, editLabel: value.label, editDefaultAddress: value.defaultAddress, addressId: value.id })
    }

    delete = (value) => {
		toast.dismiss();
        const postAddressData = {
            id: value.id, fullAddress: value.fullAddress, customerId: value.associateId, defaultAddress: value.defaultAddress
        };
        fetch(process.env.REACT_APP_NODE_ENV + '/api/address/deleteAddress', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
              },
            body: JSON.stringify(postAddressData)
        }).then(response => {
            if (response.status === 401) {
                toast.error("Default Address cannot be deleted.", {
                    position: toast.POSITION.TOP_CENTER,
                })
            } else if (response.status === 400) {
                toast.error("Yet to be Delivered Orders Available For this Address", {
                    position: toast.POSITION.TOP_CENTER,
                })
            }
            else if (response.status === 200) {
                toast.success("Address deleted successfully", {
                    position: toast.POSITION.TOP_CENTER,
                })
                this.componentDidMount();
            }
            response.json();
        })
            .then(data => console.log(data))
            .catch((err) => console.log(err))
    };

    newAddressHandler = event => {
		this.validator.showMessageFor(event.target.name)
        switch (event.target.id) {
            case "address":
                this.setState({ address: event.target.value, toggleCheckAddress: false, btnsb : '0', validmap : '0' }); break;
            case "adlabel":
                this.setState({ label: event.target.value }); break;
            case "adeditlabel":
                this.setState({ editLabel: event.target.value }); break;
            case "defaultAddressCheck":
                this.setState({ editDefaultAddress: event.target.value }); break;
            default: break;
        }
    }

    newAddress = () => {
        this.setState({ toggleAddress: true })
    };
    newAddressClickEventHandler = () => {
		if(this.state.address === "") {
			this.validator.showMessages();
            this.forceUpdate();
			this.setState({ toggleCheckAddress: false });
		} else {
			
			this.setState ({ btnsb : 1 })
			this.setState({ toggleCheckAddress: true, });
		}
    };
    toggleNewAddressModal = () => {
        this.setState({ disableSubmit: true }, () => this.addNewAddress());
    };
    popUpCancel = () => {
        this.validator.hideMessages();
        this.setState({ editAddress: false, editLabel: "", editDefaultAddress: "", toggleAddress: false, toggleCheckAddress: false, address: "", label: "", validmap : '0' })
    }

    myCallback = (dataFromChild) => {
		this.setState({ lat: dataFromChild.lat, lng: dataFromChild.lng, address: dataFromChild.fullAddress })
    }

    addAddress = () => {
        this.addNewAddress();
    }

    handleCheckBox = (event) => {
        console.log(event.target.value)
        this.setState({ editDefaultAddress: event.target.value })
    }

    render() {

        const dataArr = [];
        this.state.Data.map((data) => {
			console.log(data)
            let label = data.label
			let defaultadd="No"
			let cpFromDate = "", cpToDate = ""
			if (data.CPfromDate === null) cpFromDate = ""
			else cpFromDate = dateFormat(data.CPfromDate, "dd-mm-yyyy")
			if (data.CPtoDate === null) cpToDate = ""
			else cpToDate = dateFormat(data.CPtoDate, "dd-mm-yyyy")
            if (data.defaultAddress === "Yes") { defaultadd = "Yes" }
			
			if(data.CPtoDate)
			{
				var expire = "Active";
				var now = new Date();
				
				var order_date = new Date(dateFormat(data.CPtoDate, "yyyy-mm-dd"));
				var start_date = new Date(dateFormat(now, "yyyy-mm-dd"));					
				
				if(+start_date > +order_date)
				{
					expire = "Expired";
				}
				
			}else{
				expire = "In-Review";
			}
			
            let mdData = {
                key: data.id, title: label, Address: data.fullAddress, DefaultAddress: defaultadd, cpFromDate:cpFromDate, cpToDate:cpToDate,pricePerKL: data.pricePerKL ,  expire, actions: data
            };
            dataArr.push(mdData)

            return null;
        });
        const columns = [
            {
                name: "title",
                label: "Title",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Address",
                label: "Address",
                options: {
                    filter: true,
                    sort: true,
                }
            },
			{
                name: "DefaultAddress",
                label: "Default Address",
                options: {
                    filter: true,
                    sort: true,
                }
            },
			{
                name: "cpFromDate",
                label: "CP From Date",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "cpToDate",
                label: "CP To Date",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "pricePerKL",
                label: "Price Per KL",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "expire",
                label: "Status",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "actions",
                label: "Actions",
                options: {
                    filter: false,
                    sort: false,
                    download: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (<>
                            <Tooltip title="Edit"><IconButton onClick={() => this.editHandler(value)}><EditIcon /></IconButton></Tooltip>
                            <Tooltip title="Delete"><IconButton  onClick={() => {if(window.confirm('Are you sure you want to delete record?')){ this.delete(value)};}} ><DeleteIcon />
                            </IconButton></Tooltip></>
							
							//onClick={() => this.delete(value)}
                        );
                    }
                }
            }
        ];


        const options = {
            filterType: 'dropdown', rowsPerPageOptions: [5, 10, 15, 20], selectableRows: "none", viewColumns: false,
            downloadOptions: {
                filename: 'Delivery Address.csv',
            },
            onRowsDelete: (rowsDeleted) => {
                for (var key in rowsDeleted.data) {
                    this.delete(dataArr[rowsDeleted.data[key].index].id)
                }
            }
        };

        let newAddress = null;
        if (this.state.toggleAddress) {
            newAddress = (
                <div>
                    <Modal isOpen={true}
                        style={{ width: "1200px", display: "block" }}
                    >
                        <Card style={{ width: "50rem" }}>
                            <CardBody>
                                <ModalHeader>New Address</ModalHeader>
                                <ModalBody>
                                    <Form>
                                        <Form.Row>
                                            <Col>
												<Form.Group controlId="adlabel">
                                                    <Form.Control placeholder="Title"
                                                        value={this.state.label}
                                                        onChange={this.newAddressHandler}
                                                    ></Form.Control>
                                                    {this.validator.message("Title", this.state.label, 'required')}
                                                </Form.Group>
                                               
                                            </Col>
                                        </Form.Row>
                                        <Form.Row>
                                            <Col>
												 <Form.Group controlId="address">
                                                    <Form.Control placeholder="address"
                                                        value={this.state.address}
                                                        onChange={this.newAddressHandler}
                                                    ></Form.Control>
                                                    {this.validator.message("Address", this.state.address, 'required')}
                                                </Form.Group>
                                                
                                            </Col>
                                        </Form.Row>

                                    </Form>
                                    <Button
                                        style={{ marginTop: "10px" }}
                                        onClick={this.newAddressClickEventHandler}
                                        variant="outline-primary" >
                                        Check  </Button> {  this.state.validmap === '1' &&  <div class="text-danger">Invalid Address, Please check again</div>  }

                                    {this.state.toggleCheckAddress ? (
                                        <div className="col-md-12" style={{ marginTop: "10px" }} >
                                            {navigator.onLine ? <GeoCoding address={this.state.address} callbackFromParent={this.myCallback} /> : "You Are Not Connected To Internet"}
                                        </div>
                                    ) : null}
                                </ModalBody>
                                <ModalFooter>
								
								{this.state.btnsb === 0 &&  <Button variant="outline-success" disabled={this.disableSubmit}
                                        onClick={this.toggleNewAddressModal} >
                                        Submit
								</Button> }
							{this.state.btnsb === 1 &&  <Button variant="outline-success" disabled={this.disableSubmit}
                                        onClick={this.toggleNewAddressModal} >
                                        Submit
								</Button> }								&nbsp;&nbsp;&nbsp;
                                    <Button variant="outline-success"
                                        onClick={this.popUpCancel} >
                                        Cancel
                      </Button>
                                </ModalFooter>
                            </CardBody>
                        </Card>
                    </Modal>
                </div>
            );
        }

        let editAddress = ""
        if (this.state.editAddress) {
            editAddress = (<>
                <Modal isOpen={true}
                    style={{ width: "1200px", display: "block" }}
                >
                    <ModalBody>
                        <Card>
                            <CardBody>
                                <Form>
                                    <Form.Row>
                                        <Col>
                                            <label>Label:</label>
                                            <Form.Group controlId="adeditlabel">
                                                <Form.Control placeholder="label"
                                                    value={this.state.editLabel}
                                                    onChange={this.newAddressHandler}
                                                ></Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Form.Row>
                                    <Form.Row>
                                        <label>Default Address:</label>
                                        <select name="defaultAddresChedck" id="defaultAddressCheck" value={this.state.editDefaultAddress} onChange={this.newAddressHandler}>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                        {/* <input name="checkboxName" type="checkbox" checked={this.state.editDefaultAddress} onChange={this.handleCheckBox} /> */}
                                        {/* <Form.Group controlId="editDefaultAddress">
                                        <Form.Control type="checkbox" checked={this.state.editDefaultAddress} onChange={this.handleCheckBox}></Form.Control>
                                    </Form.Group> */}
                                    </Form.Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </ModalBody>
                    <ModalFooter>
                        <Button variant="outline-success" onClick={this.editOldAddress}>Submit</Button>&nbsp;&nbsp;&nbsp;
                        <Button variant="outline-success" onClick={this.popUpCancel}>Cancel</Button>
                    </ModalFooter>
                </Modal></>)
        }

        return (
            <>
                <Card>
                    <Card.Header>
                    </Card.Header>
                    <Card.Body>
                        <div>
                            <Button className="float-right"
                                variant="outline-success"
                                style={{ marginTop: "10px", width: "150px", marginRight: "25px" }}
                                onClick={this.newAddress}>
                                Add Address
                  </Button></div>
                        {editAddress}
                        {newAddress}
                        <div>  
                            <MUIDataTable
                                title={"Delivery Address List"}
                                data={dataArr}
                                columns={columns}
                                options={options} />
                        </div>
                    </Card.Body>
                </Card>
            </>
        );
    }
}


const mapStateToProps = (state /*, ownProps*/) => {
    return {
        userRole: state.auth.user[0].userType,
        userId: state.auth.user[0].id,
		mobiledevice: state.auth.user[0].mobiledeviceId,
    }
}

export default connect(
    mapStateToProps,
    null
)(DeliveryAddress)
